import React, { useEffect, useState } from 'react';
import { ReactComponent as EditIcon } from 'assets/icons/local-edit-icon.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import EditDepartment from './edit-department';
import AddDepartment from './add-department';
import useDashboardContext from 'contexts/dashboard.context';
import { apiService } from 'services/base.service';
import DeleteDepartemntModal from 'components/delete-department-modal';
import { handleApiError } from 'utils/functions';
import { DepartmentType } from 'models/department.model';
import { SideModal } from '@cokitchen/cokitchen-components';
import useDisableScroll from 'hooks/useDisableScroll';
type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const ManageDepartmentModal = ({ isOpen, onClose }: Props) => {
  useDisableScroll(isOpen);
  const { activeCompany } = useDashboardContext();
  const [departmentList, setDepartmentList] = useState<DepartmentType[]>([]);
  const [loading, setLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [activeDepartment, setActiveDepartment] = useState<DepartmentType | null>(null);
  const companyId = activeCompany.id;
  const getDepartmentList = async () => {
    if (!companyId) return;
    setLoading(true);
    try {
      const res = await apiService.get(`department/company/${companyId}`);
      setDepartmentList(res?.data.data);
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (companyId) {
      getDepartmentList();
    }
  }, [companyId]);
  const addDepartment = () => {
    setShowAddModal(!showAddModal);
  };
  const refreshList = () => {
    const index = departmentList.findIndex((item) => item.id === activeDepartment?.id);
    const newDepartmentList = [...departmentList];
    if (activeDepartment) {
      newDepartmentList[index] = activeDepartment;
      setDepartmentList(newDepartmentList);
    }
  };

  const handleDeleteDepartment = (id: string) => {
    setDepartmentList(departmentList.filter((dpt) => dpt.id !== id));
  };
  return (
    <SideModal
      closeBtnVariant='side'
      bodyClassName='w-[98vw] sm:w-[450px] pb-[80px]'
      showTopNavbar
      title={
        <div className='flex justify-between items-center mt-2'>
          <div>
            <p className='text-[20px] text-[#2E3031] font-medium'>Departments</p>
            <p className='text-[#6F7376]'>Manage your account information</p>
          </div>
          <button onClick={() => addDepartment()} className='text-[#E60A2B] font-medium mr-2'>
            {' '}
            + Add{' '}
          </button>
        </div>
      }
      isOpen={isOpen}
      onRequestClose={onClose}>
      <div className=' mt-4'>
        {loading ? (
          <div className='flex justify-center items-center h-[300px]'>
            <p>Loading.....</p>
          </div>
        ) : departmentList.length === 0 ? (
          <div className='flex justify-center items-center h-[300px]'>
            <p>No departments found</p>
          </div>
        ) : (
          departmentList.map((item: DepartmentType, index) => (
            <div key={index} className='flex items-center gap-3 py-[10px] '>
              <div className='flex justify-between w-[85%] border-[0.8px] border-[#EAEBEB] rounded px-[12px] py-[15px] '>
                <p className='font-medium'>{item.name}</p>
                <p className='text-[#6F7376]'>
                  {item.members ? `${item.members.length} members` : '0 members'}
                </p>
              </div>
              <EditIcon
                className='cursor-pointer'
                onClick={() => {
                  setActiveDepartment(item);
                  setShowEditModal(true);
                }}
              />
              <DeleteIcon
                className='cursor-pointer'
                onClick={() => {
                  setActiveDepartment(item);
                  setShowDeleteModal(true);
                }}
              />
            </div>
          ))
        )}
        {showEditModal && activeDepartment && (
          <EditDepartment
            show={showEditModal}
            onClose={() => {
              setShowEditModal(false);
              setActiveDepartment(null);
            }}
            activeDepartment={activeDepartment}
            onRefresh={refreshList}
          />
        )}
        {showDeleteModal && activeDepartment && (
          <DeleteDepartemntModal
            show={showDeleteModal}
            onClose={() => {
              setShowDeleteModal(false);
              setActiveDepartment(null);
            }}
            activeDepartment={activeDepartment}
            handleDeleteDepartment={handleDeleteDepartment}
          />
        )}
        <AddDepartment
          show={showAddModal}
          onClose={addDepartment}
          setDepartmentList={setDepartmentList}
          departmentList={departmentList}
        />
      </div>
    </SideModal>
  );
};

export default ManageDepartmentModal;
